import queryString from "query-string";
import { httpwmsapi } from "src/services";

export const Types = {
  REPORT_RECEIVING_LOADING: "reportReceiving/loading",
  REPORT_RECEIVING_DETAILS_LOADING: "reportReceiving/details/loading",
  REPORT_RECEIVING_SET_DATA: "reportReceiving/set/data",
  REPORT_RECEIVING_SET_DETAILS: "reportReceiving/set/details",
  REPORT_RECEIVING_SET_PAGING: "reportReceiving/set/paging",
  REPORT_RECEIVING_SET_DETAILS_PAGING: "reportReceiving/set/details/paging",
  REPORT_RECEIVING_SET_FILTER: "reportReceiving/set/filter",
  REPORT_RECEIVING_SET_FILTER_CHIP: "reportReceiving/set/filter_chip",
  REPORT_RECEIVING_SET_DIVERGENCES: "reportReceiving/set/divergences",
};

const initialState = {
  loading: false,
  loading_details: false,
  report_receiving: [],
  report_receiving_details: [],
  report_receiving_paging: { limit: 25, offset: 0, total: 0 },
  report_receiving_details_paging: { limit: 25, offset: 0, total: 0, page: 0 },
  report_receiving_filters: [],
  report_receiving_filters_chip: [],
  report_receiving_divergences: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.REPORT_RECEIVING_LOADING:
      return { ...state, loading: action.payload };
    case Types.REPORT_RECEIVING_DETAILS_LOADING:
      return { ...state, loading_details: action.payload };
    case Types.REPORT_RECEIVING_SET_DATA:
      return { ...state, report_receiving: action.payload };
    case Types.REPORT_RECEIVING_SET_DETAILS:
        return { ...state, report_receiving_details: action.payload };
    case Types.REPORT_RECEIVING_SET_PAGING:
      return { ...state, report_receiving_paging: action.payload };
    case Types.REPORT_RECEIVING_SET_DETAILS_PAGING:
      return { ...state, report_receiving_details_paging: action.payload };
    case Types.REPORT_RECEIVING_SET_FILTER:
      return { ...state, report_receiving_filters: action.payload };
    case Types.REPORT_RECEIVING_SET_FILTER_CHIP:
      return { ...state, report_receiving_filters_chip: action.payload };
    case Types.REPORT_RECEIVING_SET_DIVERGENCES:
      return { ...state, report_receiving_divergences: action.payload };
    default:
      return state;
  }
}

export const Creators = {
  reportReceivingLoading: (value) => ({
    type: Types.REPORT_RECEIVING_LOADING,
    payload: value,
  }),
  reportReceivingDetailsLoading: (value) => ({
    type: Types.REPORT_RECEIVING_DETAILS_LOADING,
    payload: value,
  }),
  reportReceivingSetData: (value) => ({
    type: Types.REPORT_RECEIVING_SET_DATA,
    payload: value,
  }),
  reportReceivingSetDetails: (value) => ({
    type: Types.REPORT_RECEIVING_SET_DETAILS,
    payload: value,
  }),
  reportReceivingSetPaging: (report_receiving_paging) => ({
    type: Types.REPORT_RECEIVING_SET_PAGING,
    payload: report_receiving_paging,
  }),
  reportReceivingSetDetailsSetPaging: (report_receiving_details_paging) => ({
    type: Types.REPORT_RECEIVING_SET_DETAILS_PAGING,
    payload: report_receiving_details_paging,
  }),
  reportReceivingSetFilters: (report_receiving_filters) => ({
    type: Types.REPORT_RECEIVING_SET_FILTER,
    payload: report_receiving_filters,
  }),
  reportReceivingSetFilterChip: (report_receiving_filters_chip) => ({
    type: Types.REPORT_RECEIVING_SET_FILTER_CHIP,
    payload: report_receiving_filters_chip,
  }),
  reportReceivingSetDivergences: (report_receiving_divergences) => ({
    type: Types.REPORT_RECEIVING_SET_DIVERGENCES,
    payload: report_receiving_divergences,
  }),

  getReportDivergencesReceiving: (filters = {}) => {
    const qry = queryString
      .stringify(filters, { arrayFormat: "index" })
      .replaceAll("%5B", "[")
      .replaceAll("%5D", "]");
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/recebimento/relatorio-divergencia?${qry}`, {
          timeout: 1000 * 60,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  getReportDivergencesReceivingDetails: (filters = {}) => {
    const qry = queryString
    .stringify(filters, { arrayFormat: "index" })
    .replaceAll("%5B", "[")
    .replaceAll("%5D", "]");
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/recebimento/relatorio-divergencia-detalhes?${qry}`, {
          timeout: 1000 * 60,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  }
  
};
